"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const index_1 = require("../index");
class PredicateInputValue extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isEditingValue: false,
        };
    }
    render() {
        const { device, value, handleAddValue, handleInputChange, numberInput } = this.props;
        const { isEditingValue } = this.state;
        const setEllipsis = (value) => {
            return isEditingValue === false
                ? {
                    whiteSpace: 'nowrap',
                    overflow: value == '' ? null : 'hidden',
                    textOverflow: 'ellipsis',
                }
                : {};
        };
        return (React.createElement("div", { style: {
                alignItems: 'center',
                display: 'flex',
                minHeight: device === 'Mobile' ? 72 : 56,
                boxSizing: 'border-box',
                borderBottom: `1px solid ${index_1.titanium}`,
            }, onClick: e => {
                e.stopPropagation();
                this.setState({
                    isEditingValue: !this.state.isEditingValue,
                });
            } },
            React.createElement("div", { style: {
                    padding: device === 'Mobile' ? '22px 0' : '14px 0',
                    display: 'flex',
                    alignItems: 'center',
                } },
                React.createElement(index_1.Text, { text: value, textStyle: Object.assign({ width: device === 'Mobile' ? 'calc(100vw - 48px)' : 350 }, setEllipsis(value)), id: "predicate-input-value-input", contentEditable: this.state.isEditingValue, onInputChange: (str) => {
                        handleInputChange(str.length === 0 ? undefined : str);
                    }, handleChange: (str) => {
                        this.setState({
                            isEditingValue: false,
                        }, () => {
                            if (str.length !== 0 && value.length !== 0) {
                                handleAddValue();
                            }
                        });
                    }, handleBlurChange: (str) => {
                        this.setState({
                            isEditingValue: false,
                        });
                    }, onBlurChange: true, placeholder: true, inputType: numberInput ? 'NUMBER' : 'ANY', placeholderText: "Value", size: "medium" }))));
    }
}
PredicateInputValue.defaultProps = {
    value: '',
    numberInput: false,
};
exports.default = PredicateInputValue;
